export const MOCK_USERS = [
  {
    id: 'u0',
    email: 'admin@nakama.gg',
    password: 'admin123',
    name: 'Mark Red',
    nickname: 'KhaZixMain99',
    avatar: 'https://images.unsplash.com/photo-1566492031773-4f4e44671857?auto=format&fit=crop&q=80&w=150&h=150',
    nationality: 'United States',
    languages: ['English', 'Spanish'],
    timezone: 'EST (UTC-5)',
    role: 'admin',
    isOnline: true,
    status: 'active',
    games: [
      { name: 'League of Legends', roles: ['Jungle', 'Top'], rank: 'Platinum', type: 'Competitive', platform: 'PC', lookingForTeam: true }
    ]
  },
  {
    id: 'u1',
    email: 'viper@nakama.gg',
    password: 'nakama123',
    name: 'Alice White',
    nickname: 'ViperQueen',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=150&h=150',
    nationality: 'United Kingdom',
    languages: ['English', 'French'],
    timezone: 'GMT (UTC+0)',
    availability: 'Evening',
    isOnline: true,
    status: 'active',
    role: 'player',
    games: [{ name: 'Valorant', roles: ['Controller', 'Sentinel'], rank: 'Diamond', type: 'Competitive', platform: 'PC', lookingForTeam: false }],
    bio: 'Looking for a duo to climb in Valorant.'
  },
  {
    id: 'u2',
    email: 'penta@nakama.gg',
    password: 'nakama123',
    name: 'Luke Ferrari',
    nickname: 'PentaSteal',
    avatar: 'https://images.unsplash.com/photo-1599566150163-29194dcaad36?auto=format&fit=crop&q=80&w=150&h=150',
    nationality: 'Italy',
    languages: ['English', 'Italian'],
    timezone: 'CET (UTC+1)',
    availability: 'Afternoon',
    isOnline: false,
    status: 'active',
    role: 'player',
    games: [{ name: 'League of Legends', roles: ['ADC', 'Support'], rank: 'Silver', type: 'Chill', platform: 'PC', lookingForTeam: true }]
  },
  {
    id: 'u3',
    name: 'Ellen Yellow',
    nickname: 'SunFlare',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=150&h=150',
    nationality: 'Canada',
    languages: ['English'],
    timezone: 'EST (UTC-5)',
    availability: 'Evening',
    isOnline: true,
    status: 'active',
    role: 'player',
    games: [{ name: 'Overwatch 2', roles: ['Support'], rank: 'Master', type: 'Competitive', platform: 'PC', lookingForTeam: false }],
    bio: 'Main Mercy/Kiriko looking for a serious team.'
  },
  {
    id: 'u4',
    name: 'Thomas Müller',
    nickname: 'BlitzKrieg',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=150&h=150',
    nationality: 'Germany',
    languages: ['German', 'English'],
    timezone: 'CET (UTC+1)',
    availability: 'Night',
    isOnline: true,
    status: 'active',
    role: 'player',
    games: [{ name: 'CS2', roles: ['AWPer', 'Entry'], rank: 'Global Elite', type: 'Competitive', platform: 'PC', lookingForTeam: true }]
  }
];

export const MOCK_CHATS = [
  {
    id: 'c1',
    user: { id: 'u3', nickname: 'SunFlare', avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=150&h=150', isOnline: true },
    lastMessage: 'Let\'s play tonight!',
    time: '10:30 AM',
    unread: 2,
    messages: [
      { sender: 'u3', text: 'Hey, are you free later?', time: '10:25 AM' },
      { sender: 'u0', text: 'Yeah, I should be around.', time: '10:28 AM' },
      { sender: 'u3', text: 'Awesome!', time: '10:29 AM' },
      { sender: 'u3', text: 'Let\'s play tonight!', time: '10:30 AM' }
    ]
  },
  {
    id: 'c2',
    user: { id: 'u4', nickname: 'BlitzKrieg', avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=150&h=150', isOnline: true },
    lastMessage: 'GGs',
    time: 'Yesterday',
    unread: 0,
    messages: [
      { sender: 'u4', text: 'GGs', time: 'Yesterday' }
    ]
  }
];

export const MOCK_NOTIFICATIONS = [
  { id: 'n1', type: 'request', user: { id: 'u1', nickname: 'ViperQueen', avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=150&h=150' }, message: 'sent you a friend request.', time: '2 hours ago', read: false },
  { id: 'n2', type: 'message', user: { id: 'u3', nickname: 'SunFlare', avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=150&h=150' }, message: 'sent you a message.', time: '10:30 AM', read: false }
];

export const GLOBAL_OPTIONS = {
  languages: ['English', 'Spanish', 'French', 'German', 'Italian', 'Japanese', 'Chinese'],
  platforms: ['PC', 'Console', 'Mobile'],
  timezones: ['CET (UTC+1)', 'GMT (UTC+0)', 'EST (UTC-5)', 'PST (UTC-8)', 'JST (UTC+9)'],
  playerTypes: ['Competitive', 'Chill', 'Mixed'],
  nationalities: ['USA', 'UK', 'France', 'Germany', 'Spain', 'Italy', 'Japan', 'Canada']
};

export const GAME_DATA = {
  'League of Legends': { roles: ['Top', 'Jungle', 'Mid', 'ADC', 'Support'], ranks: ['Iron', 'Bronze', 'Silver', 'Gold', 'Platinum', 'Emerald', 'Diamond', 'Master', 'Challenger'] },
  'Valorant': { roles: ['Duelist', 'Initiator', 'Controller', 'Sentinel'], ranks: ['Iron', 'Bronze', 'Silver', 'Gold', 'Platinum', 'Diamond', 'Ascendant', 'Immortal', 'Radiant'] },
  'CS2': { roles: ['Entry', 'AWPer', 'IGL', 'Lurker', 'Support'], ranks: ['Silver', 'Nova', 'Guardian', 'Eagle', 'Supreme', 'Global Elite'] },
  'Overwatch 2': { roles: ['Tank', 'Damage', 'Support'], ranks: ['Bronze', 'Silver', 'Gold', 'Platinum', 'Diamond', 'Master', 'Grandmaster', 'Top 500'] }
};